function setKmSliderIndex(slider, nextIndex) {
  if (!slider) return;
  const slides = Array.from(slider.querySelectorAll('[data-slide]'));
  if (!slides.length) return;

  const normalizedIndex = (nextIndex + slides.length) % slides.length;
  slides.forEach((slide, index) => {
    slide.classList.toggle('is-active', index === normalizedIndex);
  });

  slider.querySelectorAll('[data-slide-dot]').forEach((dot) => {
    dot.classList.toggle('is-active', Number(dot.dataset.slideIndex) === normalizedIndex);
  });
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-main-menu]');
    if (menu) menu.classList.toggle('is-open');
  }

  const menuSummary = event.target.closest('summary');
  const menuDropdown = menuSummary ? menuSummary.closest('[data-main-menu] details') : null;
  if (menuDropdown && !menuDropdown.open) {
    const menu = menuDropdown.closest('[data-main-menu]');
    if (menu) {
      menu.querySelectorAll('details[open]').forEach((dropdown) => {
        if (dropdown !== menuDropdown) dropdown.removeAttribute('open');
      });
    }
  }

  const menuLink = event.target.closest('[data-main-menu] a');
  if (menuLink) {
    const menu = document.querySelector('[data-main-menu]');
    if (menu) menu.classList.remove('is-open');
    menu?.querySelectorAll('details[open]').forEach((dropdown) => dropdown.removeAttribute('open'));
  }

  const sliderButton = event.target.closest('[data-slider-action]');
  if (sliderButton) {
    const slider = sliderButton.closest('[data-slider]');
    const slides = Array.from(slider.querySelectorAll('[data-slide]'));
    const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    const direction = sliderButton.dataset.sliderAction === 'next' ? 1 : -1;
    setKmSliderIndex(slider, activeIndex + direction);
    slider.dataset.sliderPausedUntil = Date.now() + 7000;
  }

  const slideDot = event.target.closest('[data-slide-dot]');
  if (slideDot) {
    const slider = slideDot.closest('[data-slider]');
    setKmSliderIndex(slider, Number(slideDot.dataset.slideIndex || 0));
    slider.dataset.sliderPausedUntil = Date.now() + 7000;
  }
});

function normalizeSearchText(value) {
  return (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function initCollectionSearch() {
  document.querySelectorAll('[data-collection-search]').forEach((form) => {
    if (form.hasAttribute('data-product-page-search')) return;
    if (form.dataset.collectionSearchReady === 'true') return;
    form.dataset.collectionSearchReady = 'true';

    const input = form.querySelector('[data-collection-search-input]');
    const section = form.closest('.km-section');
    if (!input || !section) return;

    const cards = Array.from(section.querySelectorAll('[data-product-card]'));
    const count = section.querySelector('[data-search-count]');
    const empty = section.querySelector('[data-search-empty]');
    const activeFilters = {};

    const getCardField = (card, filterName) => {
      if (filterName === 'vendor') return card.dataset.productVendor || '';
      if (filterName === 'tag') return card.dataset.productTags || '';
      if (filterName === 'available') return card.dataset.productAvailable || '';
      return card.dataset.searchText || '';
    };

    const applyProductsView = () => {
      const query = normalizeSearchText(input.value);
      let visibleCount = 0;

      cards.forEach((card) => {
        const text = normalizeSearchText(card.dataset.searchText);
        let isVisible = true;

        if (query) {
          isVisible = text.includes(query);
        } else {
          Object.entries(activeFilters).forEach(([filterName, filterValue]) => {
            if (!filterValue) return;
            const field = normalizeSearchText(getCardField(card, filterName));
            if (!field.includes(filterValue)) isVisible = false;
          });
        }

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (count) {
        count.textContent = query ? `${visibleCount} productos encontrados` : (count.dataset.defaultText && Object.keys(activeFilters).length === 0 ? count.dataset.defaultText : `${visibleCount} productos encontrados`);
      }
      if (empty) empty.hidden = visibleCount !== 0;
    };

    const applySearch = () => {
      applyProductsView();
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      applySearch();
    });
    input.addEventListener('input', applySearch);

    section.querySelectorAll('[data-product-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const filterName = button.dataset.productFilter;
        const filterValue = normalizeSearchText(button.dataset.filterValue);
        const isActive = button.classList.contains('is-active');

        section.querySelectorAll(`[data-product-filter="${filterName}"]`).forEach((item) => item.classList.remove('is-active'));
        if (isActive) {
          delete activeFilters[filterName];
        } else {
          activeFilters[filterName] = filterValue;
          button.classList.add('is-active');
        }

        input.value = '';
        applyProductsView();
      });
    });

    section.querySelector('[data-product-filter-clear]')?.addEventListener('click', () => {
      Object.keys(activeFilters).forEach((key) => delete activeFilters[key]);
      section.querySelectorAll('[data-product-filter]').forEach((button) => button.classList.remove('is-active'));
      input.value = '';
      applyProductsView();
    });

    const initialQuery = new URLSearchParams(window.location.search).get('km_search');
    if (initialQuery) {
      input.value = initialQuery;
      applyProductsView();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}

function initHeaderProductSearch() {
  document.querySelectorAll('[data-product-list-search]').forEach((form) => {
    const input = form.querySelector('[data-header-search-input]');
    if (!input) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const query = input.value.trim();
      if (!query) return;

      const collectionInput = document.querySelector('[data-collection-search-input]');
      const collectionForm = collectionInput?.closest('[data-collection-search]');

      if (collectionInput && collectionForm) {
        collectionInput.value = query;
        collectionForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        collectionInput.closest('.km-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        form.closest('[data-header-search]')?.removeAttribute('open');
        return;
      }

      window.location.href = `/collections/all?km_search=${encodeURIComponent(query)}`;
    });
  });
}

let kmFilterDisclosureWidth = window.innerWidth;

function setFilterDisclosureState() {
  const isMobile = window.matchMedia('(max-width: 640px)').matches;
  document.querySelectorAll('[data-filter-section]').forEach((section) => {
    if (section.querySelector('[data-product-filter].is-active')) {
      section.setAttribute('open', '');
    } else {
      section.removeAttribute('open');
    }
  });

  document.querySelectorAll('[data-filter-drawer]').forEach((drawer) => {
    if (!isMobile) {
      drawer.setAttribute('open', '');
    }
  });
}

document.addEventListener('DOMContentLoaded', setFilterDisclosureState);
window.addEventListener('resize', () => {
  const nextWidth = window.innerWidth;
  if (Math.abs(nextWidth - kmFilterDisclosureWidth) < 2) return;
  kmFilterDisclosureWidth = nextWidth;
  setFilterDisclosureState();
});

function initKmReveals() {
  const revealItems = document.querySelectorAll('[data-reveal], .km-animate');
  if (!revealItems.length) return;

  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16 });

  revealItems.forEach((item) => observer.observe(item));
}

function initKmTopbar() {
  const topbar = document.querySelector('[data-topbar]');
  const topbarItems = Array.from(document.querySelectorAll('[data-topbar] span')).filter((item) => item.textContent.trim());
  if (!topbarItems.length) return;

  let activeIndex = 0;
  topbarItems.forEach((item, index) => item.classList.toggle('is-active', index === activeIndex));
  topbar?.classList.add('is-ready');

  window.setInterval(() => {
    topbarItems[activeIndex].classList.remove('is-active');
    activeIndex = (activeIndex + 1) % topbarItems.length;
    topbarItems[activeIndex].classList.add('is-active');
  }, 4200);
}

function initKmStickyHeader() {
  const header = document.querySelector('[data-km-header]');
  if (!header) return;

  const updateHeader = () => {
    header.classList.toggle('is-stuck', window.scrollY > 8);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}

function initOfferSliders() {
  document.querySelectorAll('[data-offer-slider]').forEach((slider) => {
    if (slider.dataset.offerSliderReady === 'true') return;
    slider.dataset.offerSliderReady = 'true';

    const viewport = slider.querySelector('.km-weekly-offers__viewport');
    const track = slider.querySelector('[data-offer-track]');
    const firstCard = slider.querySelector('.km-offer-mini-card');
    if (!viewport || !track || !firstCard) return;

    let pauseTimer;
    let isPaused = false;

    const getStep = () => {
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const moveSlider = (direction = 1) => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth - 4;
      if (maxScroll <= 0) return;

      if (direction > 0 && viewport.scrollLeft >= maxScroll) {
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      if (direction < 0 && viewport.scrollLeft <= 4) {
        viewport.scrollTo({ left: maxScroll, behavior: 'smooth' });
        return;
      }

      viewport.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    };

    const pauseBriefly = () => {
      isPaused = true;
      window.clearTimeout(pauseTimer);
      pauseTimer = window.setTimeout(() => {
        isPaused = false;
      }, 2200);
    };

    slider.querySelectorAll('[data-offer-slide]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.offerSlide === 'next' ? 1 : -1;
        pauseBriefly();
        moveSlider(direction);
      });
    });

    slider.addEventListener('touchstart', pauseBriefly, { passive: true });

    window.setInterval(() => {
      if (!isPaused) moveSlider(1);
    }, 3000);
  });
}

function updateKmCartButtonCount(count) {
  const cartButton = document.querySelector('.km-cart-button');
  if (!cartButton) return;

  let badge = cartButton.querySelector('span');
  if (!badge && count > 0) {
    badge = document.createElement('span');
    cartButton.appendChild(badge);
  }

  if (badge) {
    badge.textContent = count;
    badge.hidden = count === 0;
  }
}

function getKmCartVariantQuantities(cart) {
  return (cart.items || []).reduce((quantities, item) => {
    quantities[item.variant_id] = (quantities[item.variant_id] || 0) + item.quantity;
    return quantities;
  }, {});
}

function updateKmCardCartNotes(quantities) {
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const variantId = card.dataset.productVariantId;
    const note = card.querySelector('[data-card-cart-note]');
    const quantityTarget = card.querySelector('[data-card-cart-quantity]');
    if (!variantId || !note || !quantityTarget) return;

    const quantity = quantities[variantId] || 0;
    quantityTarget.textContent = quantity;
    note.hidden = quantity === 0;
  });
}

function refreshKmCardCartNotes() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then((response) => {
      if (!response.ok) return null;
      return response.json();
    })
    .then((cart) => {
      if (!cart) return;
      updateKmCartButtonCount(cart.item_count);
      updateKmCardCartNotes(getKmCartVariantQuantities(cart));
    })
    .catch(() => {});
}

function initKmCardAjaxCart() {
  document.querySelectorAll('.km-card-form').forEach((form) => {
    if (form.dataset.kmCardAjaxReady === 'true') return;
    form.dataset.kmCardAjaxReady = 'true';

    const button = form.querySelector('button[type="submit"]');
    const buttonLabel = button ? button.querySelector('[data-card-button-label]') : null;
    const defaultText = buttonLabel ? buttonLabel.textContent.trim() : (button ? button.textContent.trim() : '');

    const setButtonText = (text) => {
      if (buttonLabel) {
        buttonLabel.textContent = text;
      } else if (button) {
        button.textContent = text;
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!button || button.disabled) return;

      button.disabled = true;
      setButtonText('Agregando...');

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then((response) => {
          if (!response.ok) throw new Error('No se pudo agregar.');
          return response.json();
        })
        .then(() => {
          setButtonText('Agregado');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then((response) => {
          if (!response || !response.ok) return null;
          return response.json();
        })
        .then((cart) => {
          if (!cart) return;
          updateKmCartButtonCount(cart.item_count);
          updateKmCardCartNotes(getKmCartVariantQuantities(cart));
        })
        .catch(() => {
          setButtonText('Intenta otra vez');
        })
        .finally(() => {
          window.setTimeout(() => {
            button.disabled = false;
            setButtonText(defaultText);
          }, 1400);
        });
    });
  });
}

function initKmNewsletterFeedback() {
  document.querySelectorAll('.km-newsletter, .km-newsletter-offers__form').forEach((form) => {
    if (form.dataset.kmNewsletterFeedbackReady === 'true') return;
    form.dataset.kmNewsletterFeedbackReady = 'true';

    form.addEventListener('submit', () => {
      form.classList.remove('is-clicked');
      window.requestAnimationFrame(() => {
        form.classList.add('is-clicked');
      });
    });
  });

  const postedSuccessfully = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
  if (!postedSuccessfully) return;

  const targetForm =
    document.querySelector(`${window.location.hash || '#km-newsletter-footer'} form`) ||
    document.querySelector('.km-newsletter') ||
    document.querySelector('.km-newsletter-offers__form');

  if (!targetForm || targetForm.querySelector('[data-newsletter-success]')) return;

  const message = document.createElement('p');
  message.className = 'km-newsletter-message km-newsletter-message--success';
  message.dataset.newsletterSuccess = 'true';
  message.textContent = 'Gracias por suscribirte. Revisa tu correo: te enviaremos una sorpresa y las mejores promos de KM Cero.';
  targetForm.appendChild(message);
}

function initKmHomeHeroSliders() {
  document.querySelectorAll('[data-home-hero-slider]').forEach((slider) => {
    if (slider.dataset.homeHeroSliderReady === 'true') return;
    slider.dataset.homeHeroSliderReady = 'true';

    const slides = Array.from(slider.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;

    const pause = () => {
      slider.dataset.sliderPausedUntil = Date.now() + 7000;
    };

    slider.addEventListener('mouseenter', pause);
    slider.addEventListener('touchstart', pause, { passive: true });

    window.setInterval(() => {
      const pausedUntil = Number(slider.dataset.sliderPausedUntil || 0);
      if (pausedUntil && Date.now() < pausedUntil) return;

      const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      setKmSliderIndex(slider, activeIndex + 1);
    }, 5200);
  });
}

function initKmProductHorizontalLock() {
  if (!document.querySelector('.km-product-page')) return;
  if (document.documentElement.dataset.kmProductHorizontalLock === 'true') return;
  document.documentElement.dataset.kmProductHorizontalLock = 'true';

  const resetHorizontalScroll = () => {
    if (window.scrollX !== 0) {
      window.scrollTo(0, window.scrollY);
    }

    if (document.documentElement.scrollLeft !== 0) {
      document.documentElement.scrollLeft = 0;
    }

    if (document.body.scrollLeft !== 0) {
      document.body.scrollLeft = 0;
    }
  };

  resetHorizontalScroll();
  window.setTimeout(resetHorizontalScroll, 120);
  window.addEventListener('scroll', resetHorizontalScroll, { passive: true });
  window.addEventListener('resize', resetHorizontalScroll);
}

document.addEventListener('DOMContentLoaded', () => {
  initCollectionSearch();
  initHeaderProductSearch();
  initKmReveals();
  initKmTopbar();
  initKmStickyHeader();
  initOfferSliders();
  initKmCardAjaxCart();
  initKmNewsletterFeedback();
  initKmHomeHeroSliders();
  initKmProductHorizontalLock();
  refreshKmCardCartNotes();
});

document.addEventListener('shopify:section:load', () => {
  initCollectionSearch();
  initHeaderProductSearch();
  initOfferSliders();
  initKmCardAjaxCart();
  initKmNewsletterFeedback();
  initKmHomeHeroSliders();
  initKmProductHorizontalLock();
  refreshKmCardCartNotes();
});
